import { createSelector } from 'reselect'

const appUserIdSelector = (state) => state.app.userId

export const isLoggedIn = createSelector(
  appUserIdSelector,
  (userId) => userId !== null,
)
